var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex  justify-center"},[_c('v-icon',{staticStyle:{"font-size":"52px","margin-right":"5px"},attrs:{"color":"black"},on:{"click":_vm.goBack}},[_vm._v("arrow_back")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"45px","font-weight":"bold","color":"black","-webkit-text-stroke":"2px black"}},[_vm._v("\n  "+_vm._s(_vm.titleName)+"\n  ")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3576a985","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/autoservicios/autoservicio-btn-back.vue
// module id = null
// module chunks = 